// Waitlist copy. The consent sentence and WAITLIST_CONSENT_VERSION
// must stay in step with backend CONSENT_TEXT_VERSION.

// 2026-11-02b: the consent control also includes "See the Terms."
export const WAITLIST_CONSENT_VERSION = "2026-11-02b";

export const WAITLIST_COPY = {
    headline: "Professional and Firm plans are coming.",
    detail: "Leave your details and we'll email you once when they launch. No dates promised, and no spam.",
    nameLabel: "Name",
    emailLabel: "Email",
    firmLabel: "Firm name",
    roleLabel: "Role",
    roles: ["PE", "Contractor", "Designer", "Other"],
    consent: "Yes, email me when Professional or Firm plans launch. I can unsubscribe anytime.",
    termsLead: "See the ",
    terms: "Terms",
    termsEnd: ".",
    removeLine: "To unsubscribe anytime, email support@fsr.studio.",
    rateLimit: "Your email and IP address are kept for 24 hours to limit repeated signups.",
    submit: "Notify me",
    success: "Thanks, you're on the list. We'll be in touch when they launch.",
    errorInvalid: "Check the form and try again.",
    errorRate: "Please wait and try again.",
    errorGeneric: "Something went wrong. Try again.",
};

export const UNSUBSCRIBE_COPY = {
    prompt: "Confirm you want to unsubscribe.",
    confirm: "Confirm unsubscribe",
    working: "One moment.",
    title: "You're unsubscribed.",
    body: "We won't email you about these plans.",
    invalid: "This unsubscribe link isn't valid.",
};
